import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AvatarDialogComponent } from './avatar-dialog.component';
import { TranslateModule } from '@ngx-translate/core';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { ImageCropperModule } from 'ngx-image-cropper';
import { DragAndDropDirective } from '../../../directives/drag-and-drop.directive';

const materialModules = [
    MatCardModule,
    MatButtonModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatCheckboxModule,
];
@NgModule({
    declarations: [AvatarDialogComponent, DragAndDropDirective],
    imports: [CommonModule, TranslateModule.forChild(), ...materialModules, ImageCropperModule],
})
export class AvatarDialogModule {}
